// extracted by mini-css-extract-plugin
export default {"base":"ActionReport_base__cFMSb","isDisabled":"ActionReport_isDisabled__aefC+","isCompleted":"ActionReport_isCompleted__F55UR"};